import { isEmpty } from "lodash";
import moment from "moment";
import ApiService from "../ApiService";
import PatientUtils from "./dataUtils";
import domtoimage from 'dom-to-image';
import * as pdfjsLib from 'pdfjs-dist';

export default class TiffUtils {
  static exportAllFileAsTIF = async (uploadedFileObjects, patientDetails, referralDetails) => {
    if (!uploadedFileObjects || uploadedFileObjects.length === 0) return;

    const filename =
      patientDetails.patient.full_name.replace(/\s+/g, "_") +
      "-" +
      moment().format("YYYY-MM-DD") +
      ".tif";

    try {
      const referralUuid = referralDetails.referral.id;

      const fileUrl = await ApiService.mergeReferralDocuments(referralUuid, {
        params: { format: "tif", filename: filename },
      });

      const link = document.createElement("a");
      link.href = fileUrl;
      link.click();
    } catch (err) {
      console.error("Error downloading TIFF:", err);
    }
  };

  static exportAsTif = async (documents, filename, patientDetails, referralDetails, isPrint) => {
    const myWindow = window.open();
    myWindow.document.body.style.width = '216mm';
    myWindow.document.body.style.margin = '0';

    if (!isEmpty(patientDetails) && !isEmpty(referralDetails)) {
      PatientUtils.printPatientDemographics(patientDetails, myWindow, referralDetails);
    }

    for (const docFile of documents) {
      if (docFile.type === 'application/pdf') {
        await TiffUtils.convertPdfToTiff(docFile, myWindow);
      } else {
        await TiffUtils.convertImageToTiff(docFile, myWindow);
      }
    }

    if (!isPrint) {
      domtoimage.toPng(myWindow.document.body, { quality: 1.0 }).then(dataUrl => {
        const link = document.createElement('a');
        link.setAttribute('download', filename + ".tif");
        link.href = dataUrl;
        link.click();
      });
    } else {
      myWindow.print();
    }
  };

  static convertPdfToTiff = async (pdfBlob, myWindow) => {
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    const pageWidthPx = 816;

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);

      // Get the original viewport
      const viewport = page.getViewport({ scale: 1 });
      const scale = pageWidthPx / viewport.width; // scale factor to fit 210mm width
      const scaledViewport = page.getViewport({ scale });

      const opList = await page.getOperatorList();
      const svgGfx = new pdfjsLib.SVGGraphics(page.commonObjs, page.objs);
      const svg = await svgGfx.getSVG(opList, scaledViewport);

      // Set SVG width/height to match scaled viewport
      svg.setAttribute("width", scaledViewport.width);
      svg.setAttribute("height", scaledViewport.height);

      const wrapper = document.createElement("div");
      wrapper.style.background = "white";
      wrapper.appendChild(svg);
      myWindow.document.body.appendChild(wrapper);
    }
  };

  static convertImageToTiff = async (file, myWindow) => {
    const URI = window.URL.createObjectURL(file);
    const img = new Image();

    await new Promise(resolve => {
      img.onload = () => {
        const targetWidth = 816;
        const scale = targetWidth / img.width;

        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        myWindow.document.body.appendChild(canvas);
        resolve();
      };
      img.src = URI;
    });
  };
}
